var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowHigh = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none",
    viewBox: "0 0 17 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#178715",
    d: "m8.5 4.95.547-.547-.546-.547-.547.547zm-.772 8.5a.773.773 0 1 0 1.545 0zm4.152-6.214L9.047 4.403 7.954 5.496l2.834 2.833zM7.954 4.403 5.121 7.236 6.214 8.33l2.833-2.833zm-.226.546v8.5h1.545v-8.5z"
  })));
};
export default SvgArrowHigh;